import React from "react";
import { Badge } from "reactstrap";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getPaymentStatusMeta } from "../utils/paymentStatus";
import { getContractTypeMeta } from "../utils/contractTypeBadge";

const ContractRow = ({ contract, onRowClick, canDelete, onDeleteRequest, formatCurrency }) => {
  const navigate = useNavigate();
  const statusMeta = getPaymentStatusMeta(contract.payment_status, contract.next_payment, formatCurrency);
  const typeMeta = getContractTypeMeta(contract.type);
  const client = contract.client_details;

  const kindLabel = client?.buyer_type === "LEGAL" ? "Company" : "Individual";
  const unitsCount = contract.units_count ?? 0;
  const unitsLabel = `${unitsCount} unit${unitsCount === 1 ? "" : "s"}`;

  return (
    <tr onClick={() => onRowClick(contract.id)} className="hover-row" style={{ cursor: "pointer" }}>
      <td className="fw-semibold">{contract.pvc_number}</td>
      <td>
        {client?.id ? (
          <>
            <div
              className="fw-semibold text-primary text-decoration-underline"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/client-details/${client.id}`);
              }}
            >
              {client.name}
            </div>
            <div className="text-muted" style={{ fontSize: 11.5 }}>
              {kindLabel} · {unitsLabel}
            </div>
          </>
        ) : (
          "—"
        )}
      </td>
      <td>
        <div className="d-flex align-items-center gap-2">
          <span
            style={{ width: 7, height: 7, borderRadius: "50%", background: statusMeta.dotColor, flex: "none" }}
          />
          <span className={statusMeta.textClass}>{statusMeta.label}</span>
        </div>
        {statusMeta.amountText && (
          <div className="text-muted" style={{ fontSize: 11.5 }}>{statusMeta.amountText}</div>
        )}
      </td>
      <td className="text-muted">{contract.notary || "—"}</td>
      <td>
        <Badge color={typeMeta.color} className={`badge-soft-${typeMeta.color}`}>{typeMeta.label}</Badge>
      </td>
      <td
        title={contract.notes || ""}
        style={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
      >
        {contract.notes || "—"}
      </td>
      <td className="text-end text-muted" style={{ fontVariantNumeric: "tabular-nums" }}>
        {contract.pvc_date ? moment(contract.pvc_date).format("DD MMM YYYY") : "—"}
      </td>
      <td className="text-end">
        <div className="d-flex align-items-center justify-content-end gap-2">
          {canDelete && (
            <button
              type="button"
              className="btn btn-sm btn-icon btn-ghost-danger"
              onClick={(e) => {
                e.stopPropagation();
                onDeleteRequest(contract);
              }}
            >
              <i className="ri-delete-bin-5-fill fs-16"></i>
            </button>
          )}
          <i className="ri-arrow-right-s-line text-muted"></i>
        </div>
      </td>
    </tr>
  );
};

export default ContractRow;
